import React from 'react';
import cn from 'classnames';
import css from './CEOBlock.module.scss';

interface Props {
  title: string;
  name: string;
  text: string;
  image: string;
  className?: string;
}
export default function CEOBlock({ title, name, text, image, className = '' }: Props) {
  return (
    <div className={cn('flex flex-col items-center')}>
      <div className={cn(css.ceoBlock, className)}>
        <div className={css.topInfo}>
          <div className={css.ceoImage}>
            <img src={image} alt="CEO: Gil Rabbi" />
          </div>
          <div className={css.info}>
            <h3>{title}</h3>
            <h4>{name}</h4>
          </div>
        </div>
        <div className={css.text} dangerouslySetInnerHTML={{ __html: text }}></div>
      </div>
    </div>
  );
}
